module.exports = __webpack_public_path__ + "static/img/coin_merchant.2ad7f80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bdm/coin_merchant.png
// module id = kd/T
// module chunks = 0